<template>
  <div class="az-apple-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="95"
      viewBox="0 0 82 95"
      fill="none"
    >
      <g filter="url(#filter0_d_15_1944)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.8261 25.6207C37.3945 19.1062 35.862 13.2811 33.3358 7.26947C32.2183 4.60505 36.3137 2.89315 37.4313 5.57756C40.1081 11.9555 41.7442 18.2136 42.2227 25.1245C63.8576 20.6149 80.7714 37.6573 73.31 56.1983C69.4588 62.7328 64.1354 77.1807 58.1026 81.6869C53.9603 85.5037 46.626 85.3838 44.3373 84.0516L35.9356 84.1848C30.4449 86.9358 21.2135 83.1623 19.1624 78.7427C14.5985 70.8594 11.9418 63.4256 8.81334 58.6063C-0.766127 34.0137 17.9946 20.1686 37.8261 25.6207ZM46.3081 20.7148C53.6692 0.378599 69.0104 10.9697 75.2339 3.11963C69.596 20.0654 56.1553 24.7281 46.3081 20.7148Z"
          fill="#D50808"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15_1944"
          x="0.233887"
          y="0.119629"
          width="81"
          height="94"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_1944"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_1944"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>
